import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/municipio';

export default {
  pesquisar: async (params) => {
    return financeiroApi.get(`${PATH}/pesquisar`, { params });
  },
  buscarPorIbge: (ibge) => {
    return financeiroApi.get(`${PATH}/ibge/${ibge}`);
  },
};
